<template>
  <div>
    <section v-if="!mobile">
      <section v-if="bannerMatchEventDetail === 'default'">
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundDetailPath +
            object.sport.id +
            '.webp\');background-size: cover;background-position: center center;'
          "
          v-if="object.event.type == 'match'"
        >
          <div class="d-flex-center" style="display: flex; flex: 5 1 auto">
            <v-col
              cols="12"
              md="5"
              :class="[
                'align-middle',
                getLoser(object.event.livescore.Scoreboard.Results, 'home')
                  ? 'loser'
                  : '',
              ]"
              style="justify-content: flex-end"
            >
              <div class="competitor competitor-with-field">
                <div class="name">{{ object.event.competitors.home.name }}</div>
              </div>
              <div class="team-result-home team-result-home-with-field">
                {{
                  getResult(object.event.livescore.Scoreboard.Results, 'home')
                }}
              </div>
            </v-col>

            <v-col cols="12" md="2" class="align-middle flex-center">
              <div class="match-date">
                <span
                  class="time"
                  v-if="
                    getMatchCurrentTime(
                      object.event.livescore.Scoreboard.Time
                    ) > 0
                  "
                >
                  <v-progress-circular
                    :rotate="270"
                    :size="90"
                    :width="5"
                    :value="
                      getMatchCurrentTime(
                        object.event.livescore.Scoreboard.Time
                      )
                    "
                    color="white"
                  >
                    {{
                      getMatchCurrentTime(
                        object.event.livescore.Scoreboard.Time
                      )
                    }}
                    <span class="blink_me">'</span>
                  </v-progress-circular>
                </span>
                <span class="current-period">{{
                  getMatchCurrentPeriod(
                    object.event.livescore.Scoreboard.CurrentPeriod
                  )
                }}</span>
                <span
                  v-if="
                    getUserType == 4 ||
                    getCashier ||
                    !getSettings.enableQuickBetOnlyForAgency
                  "
                  class="event-qbet"
                  title="qbet"
                >
                  {{ object.event.quickbet }}
                </span>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="5"
              :class="[
                'align-middle',
                'flex-start',
                getLoser(object.event.livescore.Scoreboard.Results, 'away')
                  ? 'loser'
                  : '',
              ]"
            >
              <div class="team-result-away team-result-away-with-field">
                {{
                  getResult(object.event.livescore.Scoreboard.Results, 'away')
                }}
              </div>
              <div class="competitor away competitor-with-field">
                <div class="name">{{ object.event.competitors.away.name }}</div>
              </div>
            </v-col>
          </div>
          <div
            style="display: flex; flex: auto; justify-content: flex-end"
            v-if="enableLiveField"
          >
            <LiveFieldWidget></LiveFieldWidget>
          </div>
        </v-row>
      </section>
      <section v-if="bannerMatchEventDetail === 'team-logo'">
        <v-row
          class="event-card-intro bannerv2 live no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundPathV2 +
            object.sport.id +
            '.webp\')'
          "
          v-if="object.event.type == 'match'"
        >
          <v-col
            class="bg-transparent no-padding flex"
            cols="12"
            sm="12"
            md="12"
          >
            <v-col
              cols="12"
              sm="5"
              md="5"
              class="no-padding align-middle flex-end competitor-widget-home"
              :class="[
                'align-middle',
                getLoser(object.event.livescore.Scoreboard.Results, 'home')
                  ? 'loser'
                  : '',
              ]"
            >
              <div class="competitor home">
                <div class="logo-home text-uppercase">
                  {{ getLogoCompetitor(object.event.competitors.home.name) }}
                </div>

                <div class="name">{{ object.event.competitors.home.name }}</div>
              </div>
              <div class="team-result-home team-result-home-with-field">
                {{
                  getResult(object.event.livescore.Scoreboard.Results, 'home')
                }}
              </div>
            </v-col>

            <v-col
              cols="12"
              sm="2"
              md="2"
              class="no-padding align-middle flex-center"
            >
              <div class="match-date">
                <span
                  class="time"
                  v-if="
                    getMatchCurrentTime(
                      object.event.livescore.Scoreboard.Time
                    ) > 0
                  "
                >
                  <v-progress-circular
                    :rotate="270"
                    :size="90"
                    :width="8"
                    :value="
                      getMatchCurrentTime(
                        object.event.livescore.Scoreboard.Time
                      )
                    "
                    color="white"
                  >
                    {{
                      getMatchCurrentTime(
                        object.event.livescore.Scoreboard.Time
                      )
                    }}
                    <span class="blink_me">'</span>
                  </v-progress-circular>
                </span>
                <span class="current-period">{{
                  getMatchCurrentPeriod(
                    object.event.livescore.Scoreboard.CurrentPeriod
                  )
                }}</span>
                <span
                  v-if="
                    getUserType == 4 ||
                    getCashier ||
                    !getSettings.enableQuickBetOnlyForAgency
                  "
                  class="event-qbet"
                  title="qbet"
                >
                  {{ object.event.quickbet }}
                </span>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="5"
              md="5"
              class="no-padding align-middle flex-start competitor-widget-away"
            >
              <div class="team-result-away team-result-away-with-field">
                {{
                  getResult(object.event.livescore.Scoreboard.Results, 'away')
                }}
              </div>
              <div
                class="competitor away"
                :class="[
                  'align-middle',
                  'flex-start',
                  getLoser(object.event.livescore.Scoreboard.Results, 'away')
                    ? 'loser'
                    : '',
                ]"
              >
                <div class="logo-away text-uppercase">
                  {{ getLogoCompetitor(object.event.competitors.away.name) }}
                </div>
                <div class="name">{{ object.event.competitors.away.name }}</div>
              </div>
            </v-col>
          </v-col>
        </v-row>
      </section>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '@/plugins/device-inspector'
import LiveFieldWidget from '@/components/generic/LiveFieldWidget.vue'

export default {
  name: 'EventCardIntroBannerLive',
  components: { LiveFieldWidget },
  data: () => ({
    modal: false,
    enableLiveField: false,
    sportBackgroundPath:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/sports-bg/',
    sportBackgroundPathV2:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/bgsport-detail/',
    sportBackgroundDetailPath:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/sports-bg-detail/',
  }),
  mounted() {
    console.log('[EventCardIntroBanner]', this.object)
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    object: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      bannerMatchEventDetail: 'uiConfig/bannerMatchEventDetail',
    }),
  },
  methods: {
    ...mapActions({}),
    getMatchCurrentPeriod(period) {
      let find = _.find(period, { lang: this.getLanguage })
      if (find) {
        return find.text
      } else {
        find = _.find(period, { lang: 'en' })
        if (find) {
          return find.text
        } else {
          return ''
        }
      }
    },
    getMatchCurrentTime(time) {
      if (time >= 0) {
        const minutes = Math.floor(time / 60)
        return minutes
      } else {
        return 0
      }
    },
    getResult(result, team) {
      if (team == 'home') {
        var point = _.find(result, { Position: '1' })
        return point ? +point.Value : 0
      } else if (team == 'away') {
        var point = _.find(result, { Position: '2' })
        return point ? +point.Value : 0
      } else {
        return 0
      }
    },
    getLoser(result, type) {
      const home_point = _.find(result, { Position: '1' })
      const away_point = _.find(result, { Position: '2' })
      if (type == 'home') {
        return +home_point.Value < +away_point.Value
      } else if (type == 'away') {
        return +away_point.Value < +home_point.Value
      }
    },
    getLogoCompetitor(str) {
      // Remove spaces
      str = str.replace(/[^a-zA-Z0-9 ]/g, '').trim()

      if (str.includes(' ')) {
        // If there are spaces, return the first letters of each word
        return str
          .split(' ')
          .map(word => word[0])
          .join('')
      } else {
        // If there are no spaces, return the first three letters
        return str.slice(0, 3)
      }
    },

    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
  },
}
</script>

<style></style>
